/* GroupingRenderer.js */

"use strict";
const ComboBoxControl = require("@gluenetworks/combobox").Single;

class GroupingRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("entity-grid-gl-grouping");

        this.groupByListCmpnt = this._createGroupingList();

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._model.addListener(
            "SetGroupingFields",
            (this._onSetGroupingOptions = this._onSetGroupingOptions.bind(this))
        );
        this._model.addListener(
            "SetGroupingValue",
            (this._onSetGroupingValue = this._onSetGroupingValue.bind(this))
        );
        this.groupByListCmpnt.addListener(
            "Value",
            (this._onGroupingChange = this._onGroupingChange.bind(this))
        );
    }
    _unregisterListeners() {
        this._model.removeListener("SetGroupingFields", this._onSetGroupingOptions);
        this._model.removeListener("SetGroupingValue", this._onSetGroupingValue);
        this.groupByListCmpnt.removeListener("Value", this._onGroupingChange);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();

        return Promise.all([]).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (/*err*/) => {}
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._rootElem.innerHTML = "";
        this._model.updateGroupingFields();
        const groupByList = this.groupByListCmpnt.renderer.rootElement;

        return new Promise((resolve /*,reject*/) => {
            this._rootElem.appendChild(groupByList);
            resolve();
        });
    }

    getRootElement() {
        return this._rootElem;
    }
    get rootElement() {
        return this.getRootElement();
    }

    getModel() {
        return this._model;
    }
    get model() {
        return this.getModel();
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _createGroupingList() {
        return new ComboBoxControl({
            allowClear: true,
            placeholder: "Group By",
            adjustWidth: true
        });
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onGroupingChange(value, prevValue, userTriggered) {
        if (userTriggered !== false) {
            this._model.userChangeGrouping(value);
        }
    }

    _onSetGroupingOptions(groupingColumns = {}) {
        const options = Object.entries(groupingColumns)
            .map(([key, col]) => ({
                label: String(col.label),
                value: key
            }))
            .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
        this.groupByListCmpnt.setOptions(options);
        this.groupByListCmpnt.setShowFilter(options.length > 5);
    }

    _onSetGroupingValue(value) {
        this.groupByListCmpnt.setValue(value, false);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = GroupingRenderer;
